export const getContinueUrl = (app) => {
  return `app/applications/form/v2/${app._id}`;
};
